/**
 * Columbia Bloque Calendario – Infinite loop carousel (custom)
 *
 * Layout inside the track:
 *   [prepended clones] [original cards] [appended clones]
 *
 * The "home" range is the originals section. When an animation lands
 * on a clone, we silently (no transition) jump back to the matching
 * original — the content is identical so the jump is invisible.
 */
(function () {
  var DEBUG = true;
  var formCtaDelegateBound = false;
  var formDialogControlsBound = false;

  /** Logs bajo [Calendario][Forms]; desactiva con `DEBUG = false` (también el resto de logs de calendario). */
  function formLog() {
    if (!DEBUG) return;
    var args = ['[Calendario][Forms]'].concat(Array.prototype.slice.call(arguments));
    console.log.apply(console, args);
  }

  function isCalendarioCtaButton(node) {
    return (
      node &&
      node.matches &&
      node.matches('button.columbia-calendario__cta[data-columbia-shopify-form-id]')
    );
  }

  function findShopifyFormTrigger(id) {
    if (!id) return null;
    var a1 = document.querySelector('a.columbia-calendario__form-popup-anchor[href="#form-' + id + '"]');
    if (a1 && !isCalendarioCtaButton(a1)) return a1;
    var a2 = document.querySelector('a.columbia-calendario__form-popup-anchor[href="#shopify-form-' + id + '"]');
    if (a2 && !isCalendarioCtaButton(a2)) return a2;
    var sels = [
      'a[href="#form-' + id + '"]',
      'a[href="#shopify-form-' + id + '"]',
      'a[href$="#' + id + '"]',
      'a[href*="#form-' + id + '"]',
      '[data-form-id="' + id + '"]',
      '[data-shopify-form-id="' + id + '"]',
    ];
    for (var j = 0; j < sels.length; j++) {
      var list = document.querySelectorAll(sels[j]);
      for (var k = 0; k < list.length; k++) {
        var n = list[k];
        if (!n || isCalendarioCtaButton(n)) continue;
        if (n.matches('a, button, [role="button"]')) return n;
        if (n.querySelector) {
          var act = n.querySelector('a, button, [role="button"]');
          if (act) return act;
        }
      }
    }
    return null;
  }

  function tryCallFormApi(maybeApi, idStr, idNum, methodName) {
    if (!maybeApi || typeof maybeApi !== 'function') return false;
    try {
      maybeApi(idStr);
      if (methodName) {
        formLog('Llamada OK:', methodName + '("' + idStr + '")');
      }
      return true;
    } catch (e) {
      if (methodName) {
        formLog('Llamada error:', methodName, e && e.message ? e.message : e);
      }
    }
    if (idNum !== null && idStr !== String(idNum)) {
      try {
        maybeApi(idNum);
        if (methodName) {
          formLog('Llamada OK:', methodName + '(', idNum, ') [id numérico]');
        }
        return true;
      } catch (e2) {
        if (methodName) {
          formLog('Llamada error:', methodName, '(núm)', e2 && e2.message ? e2.message : e2);
        }
      }
    }
    return false;
  }

  /**
   * Un intento de abrir el popup (Forms carga con el app embed, a veces tarde).
   * Devuelve true si se invocó una API o un trigger DOM — no garantiza modales
   * en builds antiguas de la app, pero dispara reintentos solo cuando falla.
   */
  function tryOpenShopifyFormPopupOnce(idStr) {
    if (!idStr) return true;
    var w = window;
    var idNum = /^\d+$/.test(idStr) ? parseInt(idStr, 10) : null;
    if (w.shopifyForms) {
      var sf = w.shopifyForms;
      if (tryCallFormApi(sf.open, idStr, idNum, 'shopifyForms.open')) return true;
      if (tryCallFormApi(sf.show, idStr, idNum, 'shopifyForms.show')) return true;
      if (tryCallFormApi(sf.showForm, idStr, idNum, 'shopifyForms.showForm')) return true;
    }
    if (w.Shopify && w.Shopify.forms) {
      if (tryCallFormApi(w.Shopify.forms.open, idStr, idNum, 'Shopify.forms.open')) return true;
      if (tryCallFormApi(w.Shopify.forms.show, idStr, idNum, 'Shopify.forms.show')) return true;
    }
    if (w.Shopify && w.Shopify.Forms) {
      if (tryCallFormApi(w.Shopify.Forms.open, idStr, idNum, 'Shopify.Forms.open')) return true;
      if (tryCallFormApi(w.Shopify.Forms.show, idStr, idNum, 'Shopify.Forms.show')) return true;
    }
    var trigger = findShopifyFormTrigger(idStr);
    if (trigger) {
      try {
        var href = trigger.getAttribute && trigger.getAttribute('href');
        formLog('Acción: trigger.click() en', trigger.tagName, href ? '(' + href + ')' : '', trigger.className || '');
        trigger.click();
        return true;
      } catch (e) {
        formLog('Error en trigger.click():', e && e.message ? e.message : e);
      }
    }
    return false;
  }

  var formOpenPending = Object.create(null);

  function openShopifyFormById(id) {
    var idStr = String(id == null ? '' : id).trim();
    if (!idStr) return;
    if (formOpenPending[idStr]) {
      formLog('Apertura ignorada: ya hay un intento en curso para formId', idStr);
      return;
    }
    formOpenPending[idStr] = true;
    formLog('Inicio openShopifyFormById — formId:', idStr);

    var w = window;
    var maxAttempts = 50;
    var attempt = 0;
    var delay = 50;

    function done() {
      formOpenPending[idStr] = false;
    }

    function tick() {
      if (attempt === 0) {
        formLog('Diagnóstico embed — formId:', idStr, {
          'window.shopifyForms': !!w.shopifyForms,
          'window.Shopify.forms': !!(w.Shopify && w.Shopify.forms),
          'window.Shopify.Forms': !!(w.Shopify && w.Shopify.Forms),
        });
      } else if (attempt > 0 && attempt % 10 === 0) {
        formLog('Sigue reintentando —', attempt, 'de', maxAttempts, '— formId', idStr, '(esperando a que cargue el embed o el script de Forms)');
      }
      if (tryOpenShopifyFormPopupOnce(idStr)) {
        formLog(
          'Lógica del tema: vía de apertura ejecutada (intento',
          attempt + 1,
          'de',
          maxAttempts + ').',
          'Si el form está inactivo o no es popup, puede no verse el modal; en ese caso el llamado aun así se registró arriba.'
        );
        done();
        return;
      }
      attempt++;
      if (attempt < maxAttempts) {
        setTimeout(tick, delay);
        return;
      }
      formLog(
        'Último recurso: eventos custom (shopify-forms:open, shopify:forms:open, open-shopify-form) con formId',
        idStr,
        '— comprobá el embed de Forms y que el form exista y esté publicado como popup'
      );
      w.dispatchEvent(
        new CustomEvent('shopify-forms:open', { detail: { formId: idStr, id: idStr, form_id: idStr }, bubbles: true, cancelable: true })
      );
      w.dispatchEvent(
        new CustomEvent('shopify:forms:open', { detail: { formId: idStr, id: idStr, form_id: idStr }, bubbles: true, cancelable: true })
      );
      var ev = w.CustomEvent
        ? new w.CustomEvent('open-shopify-form', { detail: { formId: idStr }, bubbles: true, cancelable: true })
        : null;
      if (ev) w.dispatchEvent(ev);
      formLog('Eventos custom disparados; el tema hizo toda la secuencia (revisar si la app reacciona).');
      done();
    }

    tick();
  }

  function tryOpenFormDialogFromButton(btn) {
    if (!btn) return false;
    var dialogId = (btn.getAttribute('data-columbia-form-dialog-id') || '').trim();
    if (!dialogId) return false;
    var dlg = document.getElementById(dialogId);
    if (dlg && dlg.nodeName === 'DIALOG' && typeof dlg.showModal === 'function') {
      formLog('Modal integrado (form bloque en esta sección) — showModal(), dialogId:', dialogId);
      try {
        dlg.showModal();
        return true;
      } catch (err) {
        formLog('showModal() error, fallback a API/anchors —', err && err.message ? err.message : err);
      }
    } else {
      formLog('No hay <dialog> con id (¿bloque App Forms en la sección?) —', dialogId, '— se intenta API/anchors, formId:', (btn.getAttribute('data-columbia-shopify-form-id') || '').trim());
    }
    return false;
  }

  function ensureFormDialogControls() {
    if (formDialogControlsBound) return;
    formDialogControlsBound = true;
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (!t.closest('.columbia-calendario__form-dialog')) return;
      if (t.closest('.columbia-calendario__form-dialog__close')) {
        var dlg = t.closest('dialog.columbia-calendario__form-dialog');
        if (dlg && typeof dlg.close === 'function') {
          formLog('Cerrar modal (botón) —', dlg.id);
          dlg.close();
        }
      }
    });
  }

  function ensureFormCtaDelegate() {
    if (formCtaDelegateBound) return;
    formCtaDelegateBound = true;
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var btn = t.closest('[data-columbia-shopify-form-id]');
      if (!btn) return;
      e.preventDefault();
      var fid = (btn.getAttribute('data-columbia-shopify-form-id') || '').trim();
      if (!fid) return;
      formLog('CTA clic recibido — formId:', fid);
      if (tryOpenFormDialogFromButton(btn)) return;
      openShopifyFormById(fid);
    });
  }

  function log() {
    if (!DEBUG) return;
    var args = ['[Calendario]'].concat(Array.prototype.slice.call(arguments));
    console.log.apply(console, args);
  }
  function warn() {
    if (!DEBUG) return;
    var args = ['[Calendario]'].concat(Array.prototype.slice.call(arguments));
    console.warn.apply(console, args);
  }

  function initCalendario() {
    var wrappers = document.querySelectorAll('.columbia-calendario');
    if (!wrappers.length) return;

    ensureFormDialogControls();
    ensureFormCtaDelegate();

    wrappers.forEach(function (section) {
      var carousel = section.querySelector('.columbia-calendario__carousel');
      if (!carousel || carousel.dataset.carouselInit === 'true') return;

      var cards = Array.from(carousel.querySelectorAll('.columbia-calendario__card'));
      var total = cards.length;
      if (total === 0) return;

      log('Init carousel — total cards:', total);

      /* Con menos de 3 eventos: mismo layout (track) sin clones (con 2, el clon hace “repetir” la 1.ª) */
      if (total < 3) {
        var trackSingle = document.createElement('div');
        trackSingle.className = 'columbia-calendario__track';
        cards.forEach(function (c) {
          trackSingle.appendChild(c);
        });
        var trackWrapperSingle = document.createElement('div');
        trackWrapperSingle.className = 'columbia-calendario__track-wrapper';
        trackWrapperSingle.appendChild(trackSingle);
        carousel.insertBefore(trackWrapperSingle, carousel.firstChild);
        carousel.dataset.carouselInit = 'true';
        log('Under 3 cards — static layout, no infinite carousel');
        return;
      }

      var autoplay = carousel.dataset.autoplay === 'true';
      var speed = parseInt(carousel.dataset.autoplaySpeed, 10) || 5000;

      /* ---- Build track with clones ---- */
      var track = document.createElement('div');
      track.className = 'columbia-calendario__track';

      cards.forEach(function (c) {
        var clone = c.cloneNode(true);
        clone.removeAttribute('id');
        clone.setAttribute('aria-hidden', 'true');
        clone.classList.add('is-clone');
        track.appendChild(clone);
      });

      cards.forEach(function (c) { track.appendChild(c); });

      cards.forEach(function (c) {
        var clone = c.cloneNode(true);
        clone.removeAttribute('id');
        clone.setAttribute('aria-hidden', 'true');
        clone.classList.add('is-clone');
        track.appendChild(clone);
      });

      var trackWrapper = document.createElement('div');
      trackWrapper.className = 'columbia-calendario__track-wrapper';
      trackWrapper.appendChild(track);
      carousel.insertBefore(trackWrapper, carousel.firstChild);

      /* ---- Dots ---- */
      var dotsWrap = document.createElement('div');
      dotsWrap.className = 'columbia-calendario__dots';
      for (var d = 0; d < total; d++) {
        var dot = document.createElement('button');
        dot.className = 'columbia-calendario__dot' + (d === 0 ? ' is-selected' : '');
        dot.dataset.index = d;
        dot.setAttribute('aria-label', 'Ir a tarjeta ' + (d + 1));
        dotsWrap.appendChild(dot);
      }
      carousel.appendChild(dotsWrap);

      /* ---- State ---- */
      var currentIndex = 0;
      var isAnimating = false;
      var autoplayTimer = null;
      var pendingSnap = null;

      /* ---- Measurements ---- */
      var cachedStep = null;
      function stepSize() {
        if (cachedStep !== null) return cachedStep;
        var allCards = track.querySelectorAll('.columbia-calendario__card');
        if (!allCards.length) return 300;
        var first = allCards[0];
        var second = allCards[1];
        if (second) {
          cachedStep = second.getBoundingClientRect().left - first.getBoundingClientRect().left;
        } else {
          cachedStep = first.offsetWidth + 16;
        }
        log('stepSize computed:', cachedStep);
        return cachedStep;
      }

      function txForIndex(idx) {
        return -((total + idx) * stepSize());
      }

      function setTx(px, animate) {
        if (animate) {
          track.style.transition = 'transform 0.55s cubic-bezier(0.22, 0.61, 0.36, 1)';
        } else {
          track.style.transition = 'none';
        }
        track.style.transform = 'translateX(' + px + 'px)';
      }

      function currentTx() {
        var m = track.style.transform.match(/translateX\((-?[\d.]+)px\)/);
        return m ? parseFloat(m[1]) : 0;
      }

      function snapToCanonical() {
        track.style.transition = 'none';
        track.style.transform = 'translateX(' + txForIndex(currentIndex) + 'px)';
      }

      /* ---- Dots update ---- */
      function updateDots() {
        var dots = dotsWrap.querySelectorAll('.columbia-calendario__dot');
        for (var i = 0; i < dots.length; i++) {
          if (i === currentIndex) {
            dots[i].classList.add('is-selected');
          } else {
            dots[i].classList.remove('is-selected');
          }
        }
      }

      /* ---- Navigation ---- */
      function goTo(rawIdx, animate) {
        if (isAnimating) {
          log('goTo while animating — cancelling current, queueing', rawIdx);
          isAnimating = false;
          snapToCanonical();

          void track.offsetHeight;
        }

        var canonical = ((rawIdx % total) + total) % total;
        currentIndex = canonical;
        updateDots();

        log('goTo raw:', rawIdx, '→ canonical:', canonical, 'animate:', animate);

        if (animate !== false) {
          isAnimating = true;
          setTx(txForIndex(rawIdx), true);
        } else {
          setTx(txForIndex(canonical), false);
        }
      }

      track.addEventListener('transitionend', function (e) {
        if (e.target !== track) return;
        log('transitionend — snapping to canonical index:', currentIndex);
        isAnimating = false;
        snapToCanonical();
      });

      /* ---- Init position ---- */
      setTx(txForIndex(0), false);

      /* ---- Dot clicks ---- */
      dotsWrap.addEventListener('click', function (e) {
        var dot = e.target.closest('.columbia-calendario__dot');
        if (!dot) return;
        var targetIdx = parseInt(dot.dataset.index, 10);
        log('Dot click → index:', targetIdx);
        restartAutoplay();
        goTo(targetIdx, true);
      });

      /* ---- Drag / Swipe ---- */
      var dragStartX = 0;
      var dragCurX = 0;
      var dragging = false;
      var dragBase = 0;
      var dragMoved = false;
      var dragStartTime = 0;

      function onStart(x) {
        if (isAnimating) {
          log('Drag started while animating — force-snapping');
          isAnimating = false;
          snapToCanonical();
          void track.offsetHeight;
        }
        dragging = true;
        dragMoved = false;
        dragStartX = x;
        dragCurX = x;
        dragBase = currentTx();
        dragStartTime = Date.now();
        track.style.transition = 'none';
        log('Drag start at x:', x, 'baseTx:', dragBase);
      }

      function onMove(x) {
        if (!dragging) return;
        dragCurX = x;
        if (Math.abs(dragCurX - dragStartX) > 5) dragMoved = true;
        track.style.transform = 'translateX(' + (dragBase + (dragCurX - dragStartX)) + 'px)';
      }

      function onEnd() {
        if (!dragging) return;
        dragging = false;

        var diff = dragCurX - dragStartX;
        var elapsed = Date.now() - dragStartTime;
        var velocity = Math.abs(diff) / Math.max(elapsed, 1);
        var step = stepSize();
        var threshold = step * 0.15;
        var raw = currentIndex;

        log('Drag end — diff:', diff.toFixed(1), 'elapsed:', elapsed + 'ms', 'velocity:', velocity.toFixed(2) + 'px/ms');

        var isFlick = velocity > 0.4 && Math.abs(diff) > 30;

        if (isFlick || Math.abs(diff) > threshold) {
          raw = diff < 0 ? currentIndex + 1 : currentIndex - 1;
          log('Advancing to raw index:', raw, isFlick ? '(flick)' : '(threshold)');
        } else {
          log('Below threshold, staying at:', raw);
        }

        restartAutoplay();

        var canonical = ((raw % total) + total) % total;
        currentIndex = canonical;
        updateDots();
        isAnimating = true;
        setTx(txForIndex(raw), true);

        if (dragMoved) {
          var suppress = function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
          };
          carousel.addEventListener('click', suppress, { capture: true, once: true });
        }
      }

      carousel.addEventListener('mousedown', function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        if (t.closest('button') || t.closest('a')) return;
        e.preventDefault();
        onStart(e.clientX);
      });
      document.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        e.preventDefault();
        onMove(e.clientX);
      });
      document.addEventListener('mouseup', function () {
        if (dragging) onEnd();
      });

      carousel.addEventListener('touchstart', function (e) {
        var el = e.target;
        if (el && el.closest && (el.closest('button') || el.closest('a'))) return;
        onStart(e.touches[0].clientX);
      }, { passive: true });
      carousel.addEventListener('touchmove', function (e) {
        if (dragging && dragMoved) e.preventDefault();
        onMove(e.touches[0].clientX);
      }, { passive: false });
      carousel.addEventListener('touchend', function () { onEnd(); });

      /* ---- Autoplay ---- */
      function startAutoplay() {
        if (!autoplay) return;
        autoplayTimer = setInterval(function () {
          goTo(currentIndex + 1, true);
        }, speed);
      }
      function restartAutoplay() {
        clearInterval(autoplayTimer);
        startAutoplay();
      }
      startAutoplay();

      /* ---- Resize ---- */
      var rTimer;
      window.addEventListener('resize', function () {
        clearTimeout(rTimer);
        rTimer = setTimeout(function () {
          cachedStep = null;
          setTx(txForIndex(currentIndex), false);
          log('Resize — recalculated position');
        }, 200);
      });

      carousel.dataset.carouselInit = 'true';
      log('Carousel ready');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCalendario);
  } else {
    initCalendario();
  }
  document.addEventListener('shopify:section:load', initCalendario);
})();
